<script setup>
    import { ref, onMounted, onBeforeUnmount } from 'vue'
    import {useCertificateStore} from "../../../stores/mypage/certificateStore";
    import { storeToRefs } from 'pinia';
    import moment from 'moment';
    import _ from 'lodash';
    import lectureUserService from "@/pages/user/services/lecture/lectureUserService";

    const certStore = useCertificateStore()
    const { certificate } = storeToRefs(certStore);

    const certNum = ref('');
    const lectDetail = ref({})
    const lectIndexes = ref([])
    const userDetail = ref({})

    onMounted(()=>{
        // console.log(certificate.value);
        try {
            let header = document.querySelector('header');
            let footer = document.querySelector('footer');
            let globalNav = document.querySelector('.global-nav');
            header.style.display = "none";
            footer.style.display = "none";
            globalNav.style.display = "none";
        } catch(e){}

        const newCertificate = _.cloneDeep(certificate.value);

        lectDetail.value = newCertificate.lectDetail;
        lectIndexes.value = newCertificate.lectIndexes;
        userDetail.value = newCertificate.userDetail;
        userDetail.value.birthYmd = userDetail.value.birthYmd.substring(0,4) + '-' + userDetail.value.birthYmd.substring(4,6) + '-' + userDetail.value.birthYmd.substring(6);
        // console.log(lectDetail.value);
        // console.log(lectIndexes.value);
        // console.log(userDetail.value);
        // certNum.value = `제 ${moment(lectDetail.lectEndYmd).format('YYYY')}-4-${lectDetail.value.lectId}-${userDetail.value.userCd}호`;
        // console.log(certNum.value);
        setTimeout(()=>{
            print();
        }, 100);

        certificateNum(lectDetail);
    })

    // 수료증 발급번호
    const certificateNum = (lectDetail) => {

      const userId = lectDetail.value.userId;
      const lectId = lectDetail.value.lectId;
      const regDt = lectDetail.value.regDt;

      lectureUserService.issueCertificateNum(userId, lectId, regDt)
        .then( (res) => {
          if(res.data.code.toLowerCase() === 'success') {
            const result = res.data.result;
            certNum.value = `제 ${result} 호`;
          }
        }).catch( (error) =>  {
        loadingStore.loading = false;
        console.log(error);
      });
    };

    onBeforeUnmount(()=>{
    })

    const print = () => {
        window.print();
    }

    window.onbeforeprint = function () {
    }

    window.onafterprint = function () {
    }

</script>

<template>
    <div id="cert-wrap">
        <div class="print">
            <img class="bg" src="/src/assets/images/certificates_bg.svg" alt="수료증">
            <p class="code">{{ certNum }}</p>
            <div class="user">
              <dl>
                <dt><i>성</i><i>명 : </i></dt>
                <dd>{{ userDetail.userName }}</dd>
              </dl>
              <dl>
                <dt><i>과</i><i>정</i><i>명 : </i></dt>
                <dd>{{ lectDetail.lectName }}</dd>
              </dl>
              <dl>
                <dt><i>교</i><i>육</i><i>기</i><i>간 : </i></dt>
                <dd>
                  <span v-if="lectDetail.lectGb === '01'">{{ $yyyymmdd(lectDetail.userLectStartYmd) }}~{{ $yyyymmdd(lectDetail.userLectEndYmd) }}</span>
                  <span v-else>{{ $yyyymmdd(lectDetail.lectStartYmd) }}~{{ $yyyymmdd(lectDetail.lectEndYmd) }}</span>
                </dd>
              </dl>
            </div>
            <p class="date">{{ $yyyymmdd(lectDetail.lectEndYmd) }}</p>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.print {
    position: relative;
    width: 595px;
    height: 842px;
    font-family: 'ChosunGs';
    font-size: 16px;
    .code {
        position: absolute;
        top: 120px;
        left: 64px;
        font-size: 16px;
        font-weight: 400;
    }
    .user {
      position: absolute;
      top: 271px;
      left: 64px;
      font-size: 20px;
      width: calc(100% - 128px);
      dl {
        display: flex;
        width: 100%;
        margin-bottom: 10px;
        dt {
          display: flex;
          width: 90px;
          justify-content: space-between;
          margin-right: 6px;
          i {
            font-style: normal;
          }
        }
        dd {
          width: calc(100% - 96px);
        }
      }
    }
    .date {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 251px;
      font-size: 20px;
    }
}
</style>